var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "review-bar-container d-flex",
      class: {
        disabled: _vm.isDisabled,
        active: _vm.isActive
      },
      on: { click: _vm.reviewBarClicked }
    },
    [
      _c("div", { staticClass: "label d-flex align-items-center" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.starCount) +
            " " +
            _vm._s(
              _vm.starCount === 1
                ? _vm.$t("review_star")
                : _vm.$t("review_stars")
            ) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "bar",
        style: "--review-percentage:" + _vm.percent + "%"
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "label d-flex align-items-center justify-content-end",
        domProps: { textContent: _vm._s(_vm.percent + " %") }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }